// HOOKS
import useSelected from "../../hooks/other/useSelected.other.hook";

import { createContext } from "react";

export const SelectedTicketsContext = createContext({
  selectedTickets: [],
  setSelectedTickets: () => {},
  resetSelectedTickets: () => {},
  removeSelectedTicket: () => {},
  addSelectedTickets: () => {},
});

export const SelectedTicketsProvider = ({ children }) => {
  const {
    selected: selectedTickets,
    setSelected: setSelectedTickets,
    resetSelected: resetSelectedTickets,
    removeSelected: removeSelectedTickets,
    addSelected: addSelectedTickets,
  } = useSelected([]);

  return (
    <SelectedTicketsContext.Provider
      value={{
        selectedTickets,
        setSelectedTickets,
        resetSelectedTickets,
        removeSelectedTickets,
        addSelectedTickets,
      }}
    >
      {children}
    </SelectedTicketsContext.Provider>
  );
};
